import { graphql } from "@server/gql";

export const registerUserMutation = graphql(/* GraphQL */ `
  mutation registerUser($contact: InputUser!, $brandCode: String) {
    user: registerUser(contact: $contact, brandCode: $brandCode) {
      ...user
    }
  }
`);
